import { render, staticRenderFns } from "./PrimarySurveyV2View.vue?vue&type=template&id=65439444&scoped=true&"
import script from "./PrimarySurveyV2View.vue?vue&type=script&lang=ts&"
export * from "./PrimarySurveyV2View.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65439444",
  null
  
)

export default component.exports